/** The take tools (pages), the segment store and the Playwright helpers share
 *  these; the three-layer law forbids one layer importing the other, and a
 *  helper cannot import the axios-backed wire module. */
export const TTS_VOICE_CHOICES = ['female', 'male'] as const;

export type TtsVoiceChoice = (typeof TTS_VOICE_CHOICES)[number];

/** v3's only live voice — it stays the default so an existing student hears no change. */
export const DEFAULT_TTS_VOICE_CHOICE: TtsVoiceChoice = 'female';

export const MIN_TTS_RATE = 0.5;
export const MAX_TTS_RATE = 2;
export const STEP_TTS_RATE = 0.05;
export const DEFAULT_TTS_RATE = 1;

/** Axios has no default timeout. An 800-word passage is 5+ minutes of speech, so the bound is 120 s. */
export const TTS_TIMEOUT_MS = 120000;
